import {Component} from '@angular/core';
import {RouterLinkActive, RouterLink} from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  imports: [RouterLinkActive, RouterLink],
})
export class MenuComponent {
  isMobileMenuActive: boolean = false;

  public items: ({ link: string, title: string })[] = [
    {
      "link": "/",
      "title": "Начало",
    },
    {
      "link": "/page/how-we-work",
      "title": "Как работим",
    },
    {
      "link": "/page/how-to-pay-off",
      "title": "Как да платя",
    },
    {
      "link": "/page/discounts",
      "title": "Отстъпки",
    },
    {
      "link": "/news-list",
      "title": "Новини",
    },
    {
      "link": "/contacts",
      "title": "Контакти",
    }
  ];

  protected toggleMobileMenuActivity() {
    this.isMobileMenuActive = !this.isMobileMenuActive;
  }
}
